import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import Sidebar from '../components/Sidebar';
import './FormStyles.css';

const API = 'https://cctvapi.shopkwality.in/api';

const AddCategory = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      alert('Category name is required');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${API}/categories`,
        { 
          name: name.trim(),
          description: description.trim() || undefined
        },
        { 
          headers: { Authorization: `Bearer ${token}` },
          timeout: 10000
        }
      );
      
      console.log('Category added:', response.data);
      alert('Category added successfully');
      navigate('/categories');
    } catch (err) {
      console.error('Add category error:', err);
      
      let errorMessage = 'Failed to add category';
      
      if (err.response) {
        errorMessage = err.response.data?.message || errorMessage;
        
        if (err.response.status === 403) {
          errorMessage = 'Access denied. Only staff can add categories.';
        } else if (err.response.status === 401) {
          errorMessage = 'Session expired. Please login again.';
        }
      } else if (err.request) {
        errorMessage = 'Cannot connect to server. Check your network.';
      }
      
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="form-container">
          <div className="form-header">
            <h1>Add New Category</h1>
          </div>

          <form onSubmit={handleSubmit} className="modern-form">
            <div className="form-section">
              <div className="form-group">
                <label className="form-label required">Category Name</label>
                <input
                  type="text"
                  required
                  className="form-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter category name"
                  disabled={loading}
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label className="form-label">Description</label>
                <textarea
                  className="form-textarea"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter category description (optional)"
                  rows="4"
                  disabled={loading}
                />
              </div>
            </div>

            <div className="form-actions">
              <button 
                type="submit" 
                disabled={loading} 
                className="btn btn-primary"
              >
                {loading ? (
                  <>
                    <span className="spinner"></span>
                    Adding...
                  </>
                ) : (
                  'Add Category'
                )}
              </button>
              <button 
                type="button" 
                onClick={() => navigate('/categories')} 
                className="btn btn-secondary"
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;
